import { memo, useCallback, useEffect, useState } from 'react';

import { isAndroid, isIOS } from 'react-device-detect';

import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';

import ShortFormBtnOld from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/ShortFormBtnOld';
import StyleClipAddBtnOld from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/StyleClipAddBtnOld';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import {
  BtnActnbrCate,
  BtnActnbrHeart,
  BtnActnbrHistory,
  BtnActnbrHome,
  BtnActnbrMy,
  BtnPageTopOld,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';

import * as S from './style';

interface IProps {
  isStyleClipAddBtn?: boolean;
  isShortFormBtn?: boolean | 'simple';
  isShortFormSimpleBtn?: boolean;
  styleClipTooltipPoint?: number;
  isShortFormBtnTooltip?: boolean;
  mode?: 'main' | 'sub' | string;
  gender?: 'Women' | 'Men' | 'All';
  btnTopHide?: boolean;
  btnTopShow?: boolean;
  isNativeAppBoth: boolean;
  isOldNativeAppActionBar?: boolean;
  isIPhoneXApp?: boolean;
  wckRPImage?: string;
  onClickShortForm?: () => void;
  onClickStyleClipAddBtn?: () => void;
  onClickTop?: () => void;
  onClickGender?: () => void;
  onClickHome?: () => void;
  onClickMyheart?: () => void;
  onClickMypage?: () => void;
  onClickLnb?: () => void;
  onClickHistory?: () => void;
  getHistoryImg?: () => void;
}

const ActionbarOld = ({
  isStyleClipAddBtn = false,
  isShortFormBtn = false,
  isShortFormSimpleBtn = false,
  isShortFormBtnTooltip,
  styleClipTooltipPoint,
  mode = 'main',
  gender,
  btnTopHide = false,
  btnTopShow = false,
  isNativeAppBoth,
  isOldNativeAppActionBar,
  isIPhoneXApp,
  wckRPImage,
  onClickShortForm,
  onClickStyleClipAddBtn,
  onClickTop,
  onClickGender,
  onClickHome,
  onClickMyheart,
  onClickMypage,
  onClickLnb,
  onClickHistory,
  getHistoryImg,
}: IProps) => {
  // gender
  const [cName, setClassName] = useState('ready');
  const [topBtnActive, setTopBtnActive] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    setClassName(
      classNameBind([
        'actionbarV2 ActionbarOld',
        isOldNativeAppActionBar ? 'is-old-app-iphonex' : '', // 구버전 App일때 ActionBar 위치조정 필요 여부.
        isIPhoneXApp ? 'is-old-app-iphonex' : '', // 구버전 App일때 ActionBar 위치조정 필요 여부.
        isNativeAppBoth && isAndroid ? 'is-andrd' : '',
        isNativeAppBoth && isIOS ? 'is-ios' : '',
      ])
    );
  }, [isNativeAppBoth, isIPhoneXApp, isOldNativeAppActionBar]);

  // const onPageShow = useCallback(
  //   (e: PageTransitionEvent) => {
  //     if (e.persisted) {
  //       // bfCache
  //       setRpImage(wckRPImage);
  //     } else {
  //       // 새로 진입할 때
  //       setRpImage(wckRPImage);
  //     }
  //   },
  //   [wckRPImage]
  // );

  useEffect(() => {
    const handlePopState = () => {
      // 뒤로가기 이벤트 발생 시 실행할 함수
      if (getHistoryImg) getHistoryImg();
    };

    const handlePageShow = (event: PageTransitionEvent) => {
      // 페이지가 BFCache에서 로드될 때 실행할 함수
      if (event.persisted) {
        if (getHistoryImg) getHistoryImg();
      }
    };

    const handleVisibilityChange = () => {
      // 페이지 가시성이 변경될 때 실행할 함수
      if (getHistoryImg) getHistoryImg();
    };

    // popstate 및 pageshow 이벤트 리스너 등록
    window.addEventListener('popstate', handlePopState);
    window.addEventListener('pageshow', handlePageShow);
    window.addEventListener('visibilitychange', handleVisibilityChange);

    // 컴포넌트 마운트 시 getHistoryImg 실행
    getHistoryImg?.();

    // 현재 경로에 따라 아이콘 하이라이트 설정
    const path = window.location.pathname;
    const isMainPage = path.includes('/rn/women');
    const isLnbPage = path.includes('/rn/lnb');
    const isMyheartPage = path.includes('/rn/myheart');
    const isMypagePage = path.includes('/rn/mypage');

    if (isMainPage) setActive('main');
    if (isLnbPage) setActive('category');
    if (isMyheartPage) setActive('like');
    if (isMypagePage) setActive('myPage');
    // 전부 아닐때 main으로 설정
    if (!isMainPage && !isLnbPage && !isMyheartPage && !isMypagePage)
      setActive('main');

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pageshow', handlePageShow);
      window.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // const onVisibilityChanged = useCallback(() => {
  //   setRpImage(wckRPImage);
  // }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = -document.body.getBoundingClientRect().top;

      if (scrollY > 1) {
        setTopBtnActive(true);
      } else {
        setTopBtnActive(false);
      }
    };

    const scrollListener = () => {
      window.addEventListener('scroll', handleScroll);
    };
    scrollListener();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // useEffect(() => {
  //   setRpImage(wckRPImage);
  // }, []);

  // EVENT HANDLER : 숏폼 버튼 클릭
  const onClickShortFormBtn = useCallback(() => {
    if (onClickShortForm) onClickShortForm();
  }, [onClickShortForm]);

  // EVENT HANDLER : BtnTop 클릭
  const onClickBtnTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (typeof onClickTop === 'function') onClickTop();
  }, [onClickTop]);

  // ITEM RENDERER : getActBtnSet
  const getActBtnSet = useCallback(
    () => (
      <div className="float-btn">
        {!btnTopHide && (
          <Button
            label="페이지 맨위로 이동"
            className={`top-btn btn-top${topBtnActive ? ' active' : ''}`}
            icon={<BtnPageTopOld />}
            onClick={onClickBtnTop}
          />
        )}
        {isStyleClipAddBtn && (
          <StyleClipAddBtnOld
            onClick={onClickStyleClipAddBtn}
            styleClipTooltipPoint={styleClipTooltipPoint}
            isShortFormBtnTooltip={isShortFormBtnTooltip}
          />
        )}
        {isShortFormBtn && (
          <ShortFormBtnOld
            onClick={onClickShortFormBtn}
            isSimple={isShortFormBtn === 'simple'}
          />
        )}
      </div>
    ),
    [
      btnTopHide,
      topBtnActive,
      onClickBtnTop,
      isStyleClipAddBtn,
      onClickStyleClipAddBtn,
      styleClipTooltipPoint,
      isShortFormBtnTooltip,
      isShortFormBtn,
      onClickShortFormBtn,
    ]
  );

  // ITEM RENDERER : getActionbarMain
  const getActionbarMain = useCallback(
    () => (
      <div className="actionbar-main">
        <nav>
          <ul>
            <li
              className={classNameBind([
                'main',
                active === 'main' ? 'active' : '',
              ])}
            >
              <Button
                label="홈"
                icon={<BtnActnbrHome />}
                onClick={onClickHome}
              />
            </li>
            <li
              className={classNameBind([
                'category',
                active === 'category' ? 'active' : '',
              ])}
            >
              <Button
                label="카테고리"
                icon={<BtnActnbrCate />}
                onClick={onClickLnb}
              />
            </li>
            <li
              className={classNameBind([
                'like',
                active === 'like' ? 'active' : '',
              ])}
            >
              <Button
                label="나의 관심"
                icon={<BtnActnbrHeart />}
                onClick={onClickMyheart}
              />
            </li>
            <li
              className={classNameBind([
                'myPage',
                active === 'myPage' ? 'active' : '',
              ])}
            >
              <Button
                label="마이페이지"
                icon={<BtnActnbrMy />}
                onClick={onClickMypage}
              />
            </li>
            {wckRPImage ? (
              <li
                className={classNameBind([
                  'is-history',
                  active === 'history' ? 'active' : '',
                ])}
              >
                <Button label="최근 본 상품 있음" onClick={onClickHistory}>
                  <Img src={wckRPImage} errorImg="/images/no-image.png" />
                </Button>
              </li>
            ) : (
              <li
                className={classNameBind([
                  'history',
                  active === 'history' ? 'active' : '',
                ])}
              >
                <Button
                  label="최근 본 상품"
                  onClick={onClickHistory}
                  icon={<BtnActnbrHistory />}
                />
              </li>
            )}
          </ul>
        </nav>
        {getActBtnSet()}
      </div>
    ),
    [
      active,
      getActBtnSet,
      onClickHistory,
      onClickHome,
      onClickLnb,
      onClickMyheart,
      onClickMypage,
      wckRPImage,
    ]
  );

  return (
    <>
      {cName !== 'ready' ? (
        <S.ActionbarOld id="actionbar" className={cName}>
          <div className="inner-actionbar">
            {mode === 'main' && getActionbarMain()}
          </div>
        </S.ActionbarOld>
      ) : null}
    </>
  );
};

export default memo(ActionbarOld);
